import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "semantic-ui-react";
import { DocumentRejections } from "./DocumentRejections";
import { DocumentPreview } from "./DocumentPreview";

const isImage = (filename) => /\.(gif|jpg|jpeg|tiff|png|jfif)$/i.test(filename);

export const ImageUploadSection = (props) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <div className="image-upload-section">
      <div className="image-upload-meta">
        <div className="doc-meta">
          <Icon name="thumbs down" color="red" size="big" />
          <h2>{props.header}</h2>
          <div className="doc-upload">
            <Button
              as="label"
              icon="upload"
              content="Upload"
              color="green"
              labelPosition="right"
              size="tiny"
              htmlFor={props.inputName}
            />
            <input
              hidden
              id={props.inputName}
              accept=".jpeg,.jpg,.gif,.png,.pdf"
              name={props.inputName}
              type="file"
              onChange={(e) => props.onUpload(e, props.entity)}
            />
          </div>
        </div>
        <div className="item-actions">
          <Button
            icon="eye"
            content="View Document"
            basic
            size="tiny"
            onClick={() => setPreviewOpen(true)}
          />
        </div>
      </div>
      {props.notes && props.notes.find((f) => !f.fixed) && (
        <div className="image-upload-rejections">
          <DocumentRejections
            divider={false}
            rejections={props.notes}
            size="large"
            title="Rejections"
            showIcon={false}
            color="black"
          />
        </div>
      )}
      {previewOpen && (
        <DocumentPreview
          src={props.url}
          onClose={() => setPreviewOpen(false)}
        />
      )}
    </div>
  );
};

ImageUploadSection.propTypes = {
  entity: PropTypes.string,
  header: PropTypes.string,
  inputName: PropTypes.string,
  onUpload: PropTypes.func,
  notes: PropTypes.array,
  subheader: PropTypes.string,
  url: PropTypes.string,
};
